// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselImage_root__NumUC","caption":"CarouselImage_caption__7llRj","image":"CarouselImage_image__kzMI3"};